import { StudentAlerts } from '../../../shared-components/models/student-alerts.model';

export class BehaviorStudent {
    Id: number = null;
    MemId: number = null;
    StudentId: number = null;
    FirstName = '';
    MiddleName = '';
    LastName = '';
    Nickname = '';
    StudentNumber: string = null;
    IncidentCount: number = null;
    Involvement: string = null;
    Alerts: StudentAlerts[] = [];
    Suspended = false;
    IsValidDisciplineTeam = false;
    IsUnknownStudent = false;
    PhoneNumber = '';
    Gender: string = null;
    Race = '';
    DOB: Date = null;
    Deleted = false;
    FormattedName = '';
    UserHasPermissionForStudent: boolean;
    // v9
    InvolvementType: number;
    NonStudentId: number;
    VictimStrId: string;
    VictimTypeId: number;
    VictimInjuryId: number;
    SchoolChoiceVictim: string;
 }
